import { render, staticRenderFns } from "./w-cascader-item.vue?vue&type=template&id=7fd89e67&scoped=true&"
import script from "./w-cascader-item.vue?vue&type=script&lang=js&"
export * from "./w-cascader-item.vue?vue&type=script&lang=js&"
import style0 from "./w-cascader-item.sass?vue&type=style&index=0&id=7fd89e67&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd89e67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemGroup,VListItemIcon,VListItemTitle})
